import type { SlotKey } from '#packages/apilib';
import type { EditorPermissions } from './editorPermissionsEntryPoint';

export const EditorPermissionsApiKey: SlotKey<EditorPermissions> = {
  name: 'EditorPermissionsApi',
  public: true,
};
